import React, { useEffect } from 'react'
import moment from 'moment';
import { checkTask } from 'services/task.service';
import { useStore, useDispatch } from 'react-redux';
import { removeTaskActionCreator } from 'plugins/store/reducers/tasks.reducer';
import { useSnackbar } from 'notistack';
import taskStatuses from 'utils/enums/task-statuses.enum';
import taskTypes from 'utils/enums/task-types.enum';
import { errorMessages } from 'resolvers/error-message.resolver';

import SnackMessage from 'components/Snackbar/SnackMessage';

const CHECK_ALL_TASK_INTERVAL = 10000;
const TIME_TO_LIFE_TASK = 60 * 60 * 1000;

const snackMessage = (color = 'danger') => (key, message) => (
	<SnackMessage
		id={key}
		message={message}
		color={color}
	/>
);

let timerId = null;

export default () => {
	const store = useStore();
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();

	const showMessage = (message, color) => {
		enqueueSnackbar(
			message,
			{ content: snackMessage(color) },
		);
	};

	const removeTask = (id) => {
		dispatch(removeTaskActionCreator(id));
	};

	const initTasksWatcher = () => {
		if (timerId === null) {
			timerId = setInterval(checkAllTask, CHECK_ALL_TASK_INTERVAL)
		}
	};

	useEffect(initTasksWatcher, []);

	const checkAllTask = () => {
		const { tasks: { tasks } } = store.getState();

		tasks.forEach(async ({ id, type, createdAt }) => {
			if (isTaskExpired(createdAt)) {
				return removeTask(id);
			}
			try {
				const result = await checkTask(id);
				if (result.status === taskStatuses.PENDING) {
					return;
				}

				if (result.status === taskStatuses.CANCELLED) {
					showMessage(errorMessages.DEFAULT_ERROR)
					return removeTask(id);
				}

				switch (type) {
					case taskTypes.EXPORT_PUSH_NOTIFICATIONS_CSV:
						downloadPushNotificationLogCsv(result, createdAt);
						removeTask(id);
						break;
					default:
						removeTask(id);
						break;
				}
			} catch (error) {
				showMessage(error.resolvedErrorMessage);
				removeTask(id);
			}
		});
	};

	const downloadPushNotificationLogCsv = (data, createdAt) => {
		const fileCreationTime = moment(createdAt).format('YYYY-MM-DD_HH-mm-ss');
		const blob = new Blob([data]);
		const link = document.createElement('a');

		link.href = window.URL.createObjectURL(blob);
		link.download = `Push_notifications_logs_${fileCreationTime}.csv`;
		link.click();
		showMessage('Your File has been downloaded successfully!', 'success');
	};

	const isTaskExpired = (taskCreatedAt) => {
		return new Date() - new Date(taskCreatedAt) > TIME_TO_LIFE_TASK;
	};
};
